import React from 'react';
import PropTypes from 'prop-types';
import {
    ERROR
  } from 'logic/data/Izenda.NLQConfigurationConstants';
const ProgressBar = (props) => {
    const {
        isProressBar,
        message,
        schemaStatus
      } = props;
    return (
        <div className='not_txt'>
            <div className='lds-spinner' style={{ visibility: isProressBar ? 'visible' : 'hidden' }}>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className='msg_txt'>
            <p
                style={{
                    color: !isProressBar
                      && schemaStatus == ERROR ? '#FF0000' : '#60c720'
                  }}
                className='txtmessage'
            >
                {message}
            </p>
            </div>
        </div>
    );
};
ProgressBar.defaultProps = {
    isProressBar: false,
    message: null,
    schemaStatus: null
}
ProgressBar.propTypes = {
    isProressBar: PropTypes.bool,
    message: PropTypes.string,
    schemaStatus: PropTypes.string
}
export default ProgressBar;



// WEBPACK FOOTER //
// ./ui/share/components/controls/ProgressBar/Izenda.ProgressBar.jsx